import { createSlice } from '@reduxjs/toolkit';
import { fetchContacts, createContact, fetchContactById } from './action';

const contactSlice = createSlice({
    name: 'contacts',
    initialState: {
        data: [], // Stores the list of contacts
        status: 'idle', // Tracks the state (idle, loading, success, or failed)
        error: null, // Stores any error message
        current: null, // current contact details
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch Contacts Actions
            .addCase(fetchContacts.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchContacts.fulfilled, (state, action) => {
                state.status = 'success';
                state.data = action.payload;
            })
            .addCase(fetchContacts.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            // Create Contact Actions
            .addCase(createContact.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createContact.fulfilled, (state, action) => {
                state.status = 'success';
                state.data.push(action.payload); // Add the new contact to the list
            })
            .addCase(createContact.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message; // Store the error message
            })
            // Fetch single contact
            .addCase(fetchContactById.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchContactById.fulfilled, (state, action) => {
                state.status = 'success';
                state.current = action.payload;
                // Optionally merge into list
                const idx = state.data.findIndex(c => c._id === action.payload._id);
                if (idx !== -1) state.data[idx] = action.payload; else state.data.push(action.payload);
            })
            .addCase(fetchContactById.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
    },
});

export default contactSlice.reducer;
